import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
  height: 58rem;
  min-height: fit-content;

  @media screen and (max-width: 658px) {
    height: 50rem;
  }
  @media screen and (max-width: 600px) {
    height: 45rem;
  }
  @media screen and (max-width: 520px) {
    height: 40rem;
  }
  @media screen and (max-width: 480px) {
    height: 35rem;
  }
  @media screen and (max-width: 425px) {
    height: 28rem;
  }
`;
